import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import Card from 'reusecore/src/elements/Card';
import PlaceholderImage from '@core/ui/static/images/thumb-grid-placeholder.svg';
import { Carousel } from 'react-responsive-carousel';
import Lightbox from 'react-image-lightbox';
import LazyLoad from 'react-lazyload';
import { UserContext } from '../../contexts/UserContext';
import getPhotos, { LARGE, SMALL } from '../../helpers/getPhotos';

const SliderFav = ({
  imageSrc,
  photos,
  title,
  price,
  category,
  town,
  createdAt,
  currency,
  imageStyle,
  titleStyle,
  priceStyle,
  dateStyle,
  sid,
  id,
  isLoggedIn,
  userName,
  ...props
}) => {
  const [currImg, setCurrImg] = useState(0);
  const [viewIsOpen, setViewIsOpen] = useState(false);
  const { state } = useContext(UserContext);

  const postGallery = getPhotos(imageSrc, photos, SMALL);
  let postGalleryLarge = getPhotos(imageSrc, photos, LARGE);

  postGalleryLarge = postGalleryLarge.map(photo => {
    const { thumbnail: { contentUrl } = {} } = photo;
    if (contentUrl) {
      photo.contentUrl = contentUrl;
    }

    return photo;
  });

  const gotoNext = () => {
    setCurrImg((currImg + 1) % postGalleryLarge.length);
  };
  const gotoPrevious = () => {
    setCurrImg(
      (currImg + postGalleryLarge.length - 1) % postGalleryLarge.length
    );
  };
  const closeImgsViewer = () => {
    setViewIsOpen(false);
  };
  const getZoom = () => {
    setViewIsOpen(true);
  };

  let _getHeaderComponent = () => {
    if (postGallery.length > 1) {
      return (
        <LazyLoad
          placeholder={
            <img src={PlaceholderImage} style={imageStyle} alt={title} />
          }
          offset={300}
          once
        >
          <Carousel
            swipeable={true}
            infiniteLoop={true}
            showThumbs={false}
            showStatus={false}
            onClickItem={getZoom}
            selectedItem={currImg}
            onChange={index => setCurrImg(index)}
          >
            {postGallery.map((image, index) => {
              const {
                contentUrl,
                height = null,
                source = null,
                thumbnail,
                width = null,
              } = image;
              const {
                contentUrl: thumbnailContentUrl,
                height: thumbnailHeight = null,
                source: thumbnailSource = null,
                width: thumbnailWidth = null,
              } = thumbnail || {};

              const imgSrc = thumbnail ? thumbnailContentUrl : contentUrl;
              const imgHeight = thumbnail ? thumbnailHeight : height;
              const imgSource = thumbnail ? thumbnailSource : source;
              const imgWidth = thumbnail ? thumbnailWidth : width;

              return (
                <picture key={index}>
                  {imgSource}
                  <img
                    key={index}
                    src={imgSrc}
                    onClick={getZoom}
                    alt={title}
                    style={imageStyle}
                    height={imgHeight}
                    width={imgWidth}
                    loading="lazy"
                  />
                </picture>
              );
            })}
          </Carousel>
        </LazyLoad>
      );
    } else {
      let imgSrc = PlaceholderImage;
      let imgSource = null;

      let imgHeight = null;
      let imgWidth = null;

      if (postGallery.length > 0) {
        const {
          contentUrl,
          height = null,
          source = null,
          thumbnail,
          width = null,
        } = postGallery[0];
        const {
          contentUrl: thumbnailContentUrl,
          height: thumbnailHeight = null,
          source: thumbnailSource = null,
          width: thumbnailWidth = null,
        } = thumbnail || {};

        imgSrc = thumbnail ? thumbnailContentUrl : contentUrl;
        imgHeight = thumbnail ? thumbnailHeight : height;
        imgSource = thumbnail ? thumbnailSource : source;
        imgWidth = thumbnail ? thumbnailWidth : width;
      }

      return (
        <LazyLoad
          placeholder={
            <img src={PlaceholderImage} style={imageStyle} alt={title} />
          }
          offset={300}
          once
        >
          <picture>
            {imgSource}
            <img
              src={imgSrc}
              onClick={postGallery.length > 0 ? getZoom : null}
              alt={title}
              style={imageStyle}
              height={imgHeight}
              width={imgWidth}
              loading="lazy"
            />
          </picture>
        </LazyLoad>
      );
    }
  };

  const ComponentCardHeader = _getHeaderComponent();

  return (
    <>
      {viewIsOpen && (
        <Lightbox
          mainSrc={postGalleryLarge[currImg].contentUrl}
          nextSrc={
            postGalleryLarge.length > 1
              ? postGalleryLarge[(currImg + 1) % postGalleryLarge.length]
                  .contentUrl
              : ''
          }
          prevSrc={
            postGalleryLarge.length > 1
              ? postGalleryLarge[
                  (currImg + postGalleryLarge.length - 1) %
                    postGalleryLarge.length
                ].contentUrl
              : ''
          }
          onCloseRequest={closeImgsViewer}
          onMovePrevRequest={gotoPrevious}
          onMoveNextRequest={gotoNext}
        />
      )}
      <Card {...props}>{ComponentCardHeader}</Card>
    </>
  );
};

SliderFav.propTypes = {
  category: PropTypes.string,
  town: PropTypes.string,
  title: PropTypes.string,
  owner: PropTypes.string,
  deleteAds: PropTypes.func,
  imageSrc: PropTypes.array,
  imageStyle: PropTypes.object,
};

SliderFav.defaultProps = {
  boxShadow: 'none',
  borderRadius: '0px',
  owner: null,
  deleteAds: null,
  mb: '2%',
  bg: 'white',
  hn: 'h4',
  imageStyle: {
    width: '190px',
    height: '100px',
    objectFit: 'cover',
    backgroundPosition: '50% 50%',
    maxWidth: '100%',
  },
};

export default SliderFav;
